import React from 'react';

// ProgrammePlaceholder — a tiny stand-in for the programme surfaces that the
// AppShell nav links to but which land in later slices (007-dashboard-shell:
// the shell + dashboard ship now; Vision, Value streams, Domains, Systems,
// Validation, Prioritisation, Golden thread, Sources follow). It keeps the nav
// honest — every destination resolves to a calm "coming soon" surface rather
// than a dead end. Tokens only.

const ProgrammePlaceholder: React.FC<{ title: string }> = ({ title }) => (
  <div
    style={{
      padding: '48px 32px',
      maxWidth: 720,
      color: 'var(--ap-text-dim)',
      fontFamily: 'var(--dd-font-sans)',
    }}
  >
    <h1
      style={{
        margin: '0 0 8px',
        fontSize: 22,
        fontWeight: 600,
        letterSpacing: '-0.01em',
        color: 'var(--ap-ink)',
      }}
    >
      {title}
    </h1>
    <p style={{ margin: 0, fontSize: 15, lineHeight: 1.5 }}>
      This surface is coming in a later slice. The navigation is in place so the
      programme reads as an app today.
    </p>
  </div>
);

export default ProgrammePlaceholder;
